import { render, staticRenderFns } from "./BaseFragment.vue?vue&type=template&id=52554e2c"
import script from "./BaseFragment.vue?vue&type=script&lang=js"
export * from "./BaseFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports